import { Typography, CircularProgress, Box } from "@material-ui/core";

const LoadingProgressComponent = ({
  progValue,
  value,
}: {
  progValue: number;
  value: number;
}) => {
  const percentValue = (progValue / value) * 100;

  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant="determinate"
        size={100}
        value={Math.ceil(percentValue)}
        style={{ color: "#FFFFFF" }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body1">{`${progValue}/${value}`}</Typography>
      </Box>
    </Box>
  );
};

export default LoadingProgressComponent;
